import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import FaqAccordion from '@components/FaqAccordion'
import FaqSectionWrapper from '@components/FaqSectionWrapper'

import { scoredTableFaqContent } from './utils/ScoredTableFaqContent'

const ScoredTableFaqs = ({
    activeCategory,
}: {
    activeCategory: CreditCardProductCategory
}) => (
    <FaqSectionWrapper>
        {scoredTableFaqContent[activeCategory]?.map(
            ({ answer, question }, i) => (
                <FaqAccordion
                    key={`${question}-${i}`}
                    heading={question}
                    isOpen={i === 0}
                >
                    {answer}
                </FaqAccordion>
            )
        )}
    </FaqSectionWrapper>
)

export default ScoredTableFaqs
